'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StandardDisclaimer = function (_Component) {
  (0, _inherits3.default)(StandardDisclaimer, _Component);

  function StandardDisclaimer() {
    (0, _classCallCheck3.default)(this, StandardDisclaimer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(StandardDisclaimer).call(this));

    _this.state = {
      hoverIndex: -1
    };
    return _this;
  }

  (0, _createClass3.default)(StandardDisclaimer, [{
    key: 'render',
    value: function render() {
      var styles = require('./StandardDisclaimer.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.tactTitle },
          '免责声明'
        ),
        _react2.default.createElement('div', { className: styles.tactLink }),
        _react2.default.createElement(
          'div',
          { className: styles.tactTxt },
          _react2.default.createElement(
            'p',
            { className: styles.content },
            '1、艺品网平台上关于会员发布的任何信息（包括但不限于注册信息、企业/个人信息、店铺名称、联系人及联络信息、产品的描述和说明、图片、视频、言论等）均由会员自行提供，因此而产生的责任均由会员提供者本人全部承担，与艺品网平台无关。'
          ),
          _react2.default.createElement(
            'p',
            { className: styles.content },
            '2、本平台因维护、升级可能会不定期的中断提供服务；因您操作不当、电脑病毒或黑客攻击可能也会引发暂时的服务中断。您接受本声明，视为同意上述单方面的服务中断。本平台将会对可预料的中断服务提供告知（如在平台上公告或以电子邮件或短信等方式通知）。如发生服务中断，本平台会争取在最短的时间内恢复服务。但是，因上述原因导致您遭受的损失，由您本人承担。'
          ),
          _react2.default.createElement(
            'p',
            { className: styles.content },
            '3、本平台对于因战争、地震、洪水、火灾等不可抗力原因或互联网运输问题、信号线路问题等其他不可预见、不可控制的原因而导致本平台无法正常提供服务，或者导致您的信息泄露、利益受损不负责任。但是，本平台会在上述事由发生后积极挽救，努力使您的利益损失降到最低。'
          )
        )
      );
    }
  }]);
  return StandardDisclaimer;
}(_react.Component); /**
                      * Created by zfc on 2016/9/13.
                      */


exports.default = StandardDisclaimer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/StandardDisclaimer/StandardDisclaimer.js
 ** module id = 1548
 ** module chunks = 0
 **/